import { createIcon } from "@chakra-ui/react";

export const ZipIcon = createIcon({
  displayName: "ZipIcon",
  viewBox: "0 0 16 20",
  defaultProps: {
    width: "16",
    height: "20",
    fill: "none",
  },
  path: (
    <>
      <path d="M6 1V5C6 5.26522 5.89464 5.51957 5.70711 5.70711C5.51957 5.89464 5.26522 6 5 6H1M15 2V18C15 18.2652 14.8946 18.5196 14.7071 18.7071C14.5196 18.8946 14.2652 19 14 19H2C1.73478 19 1.48043 18.8946 1.29289 18.7071C1.10536 18.5196 1 18.2652 1 18V5.914C1.00006 5.64881 1.10545 5.39449 1.293 5.207L5.207 1.293C5.39449 1.10545 5.6488 1.00006 5.914 1H14C14.2652 1 14.5196 1.10536 14.7071 1.29289C14.8946 1.48043 15 1.73478 15 2Z" stroke="black" strokeWidth="1" strokeLinecap="round"/>
      {/* Dots as circles */}
      <circle cx="11" cy="3" r="0.5" fill="black" />
      <circle cx="9" cy="5" r="0.5" fill="black" />
      <circle cx="11" cy="7" r="0.5" fill="black" />
      <circle cx="9" cy="9" r="0.5" fill="black" />
      <circle cx="11" cy="11" r="0.5" fill="black" />
      <circle cx="9" cy="13" r="0.5" fill="black" />
      <circle cx="11" cy="15" r="0.5" fill="black" />
      <circle cx="9" cy="17" r="0.5" fill="black" />
    </>
  ),
});
